import script from "./OrderProductOffers.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderProductOffers.vue?vue&type=script&setup=true&lang=js"

import "./OrderProductOffers.vue?vue&type=style&index=0&id=c72de7a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c72de7a8"]])

export default __exports__